var vimeoPlayer = {

    elements: {},
    players: [],

    init: function() {
        var _self = this;

        if(!this.getElements()) {
            return;
        }

        this.loadPlayers(function() {
            _self.setPlayerColour();
            _self.setEvents();
        });
    },

    getElements: function() {
        this.elements.iframes = jQuery('.vimeo-player__iframe');
        if(!this.elements.iframes.length) {
            return false;
        }

        this.elements.playButtons = jQuery('.vimeo-player__play-button');
        if(!this.elements.playButtons.length) {
            return false;
        }

        this.elements.pauseButtons = jQuery('.vimeo-player__pause-button');
        if(!this.elements.pauseButtons.length) {
            return false;
        }

        return true;
    },

    loadPlayers: function(callback) {
        var _self = this;

        this.elements.iframes.on('load', function() {
            if(_self.players.length == _self.elements.iframes.length) {
                return;
            }

            _self.players.push(new Vimeo.Player(jQuery(this).get(0)));

            if(_self.players.length != _self.elements.iframes.length) {
                return;
            }

            callback();
        });
    },

    setPlayerColour: function() {
        for(var i=0; i<this.players.length; i++) {
            this.players[i].setColor('263039');
        }
    },

    setEvents: function() {
        var _self = this;

        this.elements.playButtons.on('click', function() {
            var playButton = jQuery(this);
            var player = _self.getPlayerFromButton(playButton);

            if(!player) {
                return;
            }

            var pauseButton = playButton.siblings('.vimeo-player__pause-button');

            if(!pauseButton.length) {
                return;
            }

            playButton.fadeOut();
            pauseButton.addClass('pause-button-hover');
            player.setMuted(true);
            player.play();
        });

        this.elements.pauseButtons.on('click', function() {
            var pauseButton = jQuery(this);
            var player = _self.getPlayerFromButton(pauseButton);

            if(!player) {
                return;
            }

            var playButton = pauseButton.siblings('.vimeo-player__play-button');

            if(!playButton.length) {
                return;
            }

            playButton.fadeIn();
            pauseButton.removeClass('pause-button-hover');
            player.pause();
        });
    },

    getPlayerFromButton: function(button) {
        var iframe = button.parents('.vimeo-player').find('.vimeo-player__iframe');

        if(!iframe.length) {
            return false;
        }

        for(var i=0; i<this.players.length; i++) {
            if(!iframe.is(this.players[i].element)) {
                continue;
            }

            return this.players[i];
        }

        return false;
    }

};

jQuery(document).ready(function() {
    vimeoPlayer.init();
});